/**
 * US English crisis resources. Mirrors the server-side `CRISIS_RESOURCES`
 * block in `server/app/common/crisis/errors.py`.
 *
 * The server inlines the same block in 423 cooldown responses, so callers
 * that need to show the modal _without_ a server response (the drawer item
 * and the chat footer) use these constants directly. Keep the two
 * definitions in sync; there is no derivation between them.
 */
export const crisisResources = {
  lifeline: {
    label: "Suicide and Crisis Lifeline",
    phone: "988",
    sms: "988"
  },
  crisisTextLine: {
    label: "Crisis Text Line",
    smsKeyword: "HOME",
    smsNumber: "741741"
  },
  emergency: {
    label: "Emergency Services",
    phone: "911"
  },
  protocolUrl: "https://app.serenit.ai/crisis"
} as const;
